const baseButton = {
  fontFamily: 'Inter',
  fontWeight: 400,
  lineHeight: '150%',
  fontSize: '12px',
  textTransform: 'capitalize',
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: 'rgb(252, 252, 252)',
  },
};

export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 16px',
    borderTop: '1px solid #EDEFF7',
  },
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  completeButton: {
    ...baseButton,
    color: '#23252F',
    border: '1px solid #F3F4F9',
  },
  deleteButton: {
    ...baseButton,
    color: '#FF0000',
    border: '1px solid #FF0000',
  },
};
